var map = {
	"./ebirah_full.png": 8609,
	"./ebirah_game.png": 2537,
	"./ebirah_moves.png": 2498,
	"./ebirah_side.png": 7085,
	"./general_game.png": 8508,
	"./general_side.png": 7987,
	"./giant_squid_full.png": 9067,
	"./giant_squid_game.png": 1999,
	"./giant_squid_moves.png": 1546,
	"./giant_squid_side.png": 8312,
	"./jormungandr_full.png": 4705,
	"./jormungandr_game.png": 4895,
	"./jormungandr_moves.png": 43,
	"./jormungandr_side.png": 8544,
	"./kraken_full.png": 1530,
	"./kraken_game.png": 4461,
	"./kraken_moves.png": 6088,
	"./kraken_side.png": 2689,
	"./leviathan_full.png": 1607,
	"./leviathan_game.png": 3639,
	"./leviathan_moves.png": 1418,
	"./leviathan_side.png": 5369,
	"./loch_ness_full.png": 8631,
	"./loch_ness_game.png": 5262,
	"./loch_ness_moves.png": 5485,
	"./loch_ness_side.png": 6234,
	"./megalodon_full.png": 5336,
	"./megalodon_game.png": 4335,
	"./megalodon_moves.png": 5794,
	"./megalodon_side.png": 7610,
	"./sea_hydra_full.png": 5603,
	"./sea_hydra_game.png": 1586,
	"./sea_hydra_moves.png": 5,
	"./sea_hydra_side.png": 7242,
	"./siren_full.png": 7303,
	"./siren_game.png": 8344,
	"./siren_moves.png": 6495,
	"./siren_side.png": 8971,
	"./white_whale_full.png": 568,
	"./white_whale_game.png": 2406,
	"./white_whale_moves.png": 1500,
	"./white_whale_side.png": 6468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3058;